import { ShaderMaterial } from "three";
import { UniformsUtils } from "three";
import { BaseReflector } from "./_BaseReflector";
import VERTEX from "./reflector/vert.glsl";
import FRAGMENT from "./reflector/frag.glsl";
const ReflectorShader = {
  uniforms: {
    color: {
      value: null
    },
    tDiffuse: {
      value: null
    },
    textureMatrix: {
      value: null
    },
    opacity: {
      value: 0.5
    }
  },
  vertexShader: VERTEX,
  fragmentShader: FRAGMENT
};
export class Reflector extends BaseReflector {
  constructor(geometry, _options) {
    super(geometry, _options);
    this.geometry = geometry;
    this._options = _options;
  }
  _createMaterial() {
    const material = new ShaderMaterial({
      uniforms: UniformsUtils.clone(ReflectorShader.uniforms),
      fragmentShader: ReflectorShader.fragmentShader,
      vertexShader: ReflectorShader.vertexShader
    });
    material.uniforms["color"].value = this._options.color;
    material.uniforms["textureMatrix"].value = this.textureMatrix;
    material.uniforms["opacity"].value = this._options.opacity;
    material.transparent = this._options.opacity < 1;
    return material;
  }
  _assignMaterialRenderTarget() {
    if (this.renderTarget) {
      this.material.uniforms["tDiffuse"].value = this.renderTarget.texture;
    }
  }
  clone(recursive) {
    const clonedOptions = { ...this._options };
    clonedOptions.color = this._options.color.clone();
    const clonedGeometry = this.geometry.clone();
    const clonedReflector = new Reflector(clonedGeometry, clonedOptions);
    const { material } = clonedReflector;
    clonedReflector.copy(this, recursive);
    clonedReflector.material = material;
    clonedReflector.geometry = clonedGeometry;
    clonedReflector.updateMatrix();
    return clonedReflector;
  }
}
